import React from "react";
import iconContact from "../assets/img/icon_contact.svg";

const ContactThanks = () => {
  return (
    <section className="section email-section">
      <h2 className="section-title">
        <i>
          <img src={iconContact} alt="" />
        </i>
        お問い合わせ
      </h2>

      <div className="group-wrapper">
        <div className="form-group">
          <p
            style={{
              textAlign: "center",
              padding: "3em 1em",
              lineHeight: "1.8",
              fontSize: "0.95rem",
            }}
          >
            お問い合わせ内容が送信されました。
            <br />
            送信内容につきましてはお客様のメールアドレス宛に
            <br />
            自動返信メールをお送りしておりますので、ご確認ください。
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactThanks;
